import React from "react";

function PaginationControls({ page, setPage, totalPages }) {

    // 🔥 Prevent divide by zero / invalid state
    const safeTotalPages = totalPages || 1;

    return (
        <div style={{
            display: "flex",
            justifyContent: "flex-end",
            alignItems: "center",
            marginTop: "10px",
            gap: "10px",
            fontSize: "12px",
            fontFamily: "Verdana"
        }}>

            {/* PREV */}
            <button
                onClick={() =>
                    setPage(prev => Math.max(prev - 1, 0))
                }
                disabled={page === 0}
                style={{
                    padding: "3px 10px",
                    cursor: page === 0 ? "not-allowed" : "pointer"
                }}
            >
                Prev
            </button>

            {/* PAGE INFO */}
            <span>
                Page {page + 1} of {safeTotalPages}
            </span>

            {/* NEXT */}
            <button
                onClick={() =>
                    setPage(prev => Math.min(prev + 1, safeTotalPages - 1))
                }
                disabled={page === safeTotalPages - 1}
                style={{
                    padding: "3px 10px",
                    cursor: page === safeTotalPages - 1 ? "not-allowed" : "pointer"
                }}
            >
                Next
            </button>

        </div>
    );
}

export default PaginationControls;